import type { BlobLike, CacheBackend } from "@pdfking/compatibility"
import { BlobCreate } from "@pdfking/compatibility"
import { IsNull } from "@pdfking/tfunc"

const to_key = (file_id: string) => `https://cache/${file_id}`

export const FileCache = (cacheName: string): CacheBackend<BlobLike> => ({
  async clear(): Promise<void> {
    await caches.delete(cacheName)
  },
  async delete(key: string): Promise<void> {
    const c = await caches.open(cacheName)
    await c.delete(to_key(key))
  },
  async exists(key: string): Promise<boolean> {
    const c = await caches.open(cacheName)
    const match = await c.match(to_key(key))
    return !IsNull(match)
  },
  async get(key: string): Promise<BlobLike | undefined> {
    const c = await caches.open(cacheName)
    const response = await c.match(to_key(key))
    if (!response) return undefined
    return response.blob().then(BlobCreate)
  },
  async set(key: string, blob: BlobLike): Promise<void> {
    const c = await caches.open(cacheName)
    await c.put(to_key(key), new Response(await blob.arrayBuffer()))
  },
})
